import React from 'react';

const ClientTooltip = ({ hoveredClient }) => {
  if (!hoveredClient) return null;

  // Get client details with enhanced handling for new data structure
  const getClientDetails = (client) => {
    return {
      // Financial information - now with proper formatting
      revenue: client['Total Revenue'] || '$0.00',
      lastBookingRevenue: client['Last Booking Revenue'] || 'N/A',
      lastBooked: client['Last Booked'] || 'N/A',
      
      // Contact information - with improved defaults
      contactName: client['Key Contact Name'] || 'Contact Representative',
      contactEmail: client['Key Contact Email'] || 'contact@client.com',
      previousManager: client['Previously Assigned Manager'] || 'None',
      
      // New fields available from portfolio data
      timeZone: client['Time zone'] || 'N/A',
      tier: client['Tier'] || 'N/A',
      segment: client['Segment'] || 'N/A',
      rn: client['RN'] || 'N/A'
    };
  };

  const details = getClientDetails(hoveredClient);

  return (
    <div 
      className="client-tooltip"
      style={{
        top: `${hoveredClient.y}px`,
        left: `${hoveredClient.x}px`,
      }}
    >
      <h4>{hoveredClient.client_name}</h4>
      <div className="tooltip-grid">
        {/* Financial Information - First Row */}
        <div className="tooltip-item">
          <span className="label">Total Revenue:</span>
          <span className="value revenue">{details.revenue}</span>
        </div>
        <div className="tooltip-item">
          <span className="label">Last Booking:</span>
          <span className="value">{details.lastBooked}</span>
        </div>
        
        {/* Client Tier and Time Zone - Second Row */}
        <div className="tooltip-item">
          <span className="label">Client Tier:</span>
          <span className="value tier">{details.tier}</span>
        </div>
        <div className="tooltip-item">
          <span className="label">Time Zone:</span>
          <span className="value">{details.timeZone}</span>
        </div>
        
        {/* Last Booking Revenue - Third Row */}
        <div className="tooltip-item full-width">
          <span className="label">Last Booking Revenue:</span>
          <span className="value revenue">{details.lastBookingRevenue}</span>
        </div>
        
        {/* Contact Information - Fourth Row */}
        <div className="tooltip-item">
          <span className="label">Total Rooms:</span>
          <span className="value">{hoveredClient.group_size}</span>
        </div>
        <div className="tooltip-item">
          <span className="label">Total RN:</span>
          <span className="value">{hoveredClient.RN || details.rn || 'N/A'}</span>
        </div>
        
        {/* Segment and RN - Fifth Row */}
        <div className="tooltip-item">
          <span className="label">Last Booked Conference:</span>
          <span className="value">{details.segment}</span>
        </div>
        <div className="tooltip-item">
          <span className="label">RN:</span>
          <span className="value">{details.rn}</span>
        </div>
        
        {/* Previous Manager - Sixth Row */}
        <div className="tooltip-item full-width">
          <span className="label">Previously Assigned Manager:</span>
          <span className="value">
            {details.previousManager || 'None'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ClientTooltip;
